// @flow

export default {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  DECLINED: 'DECLINED',
  INACTIVE: 'INACTIVE',
}
